import { useSnapshot } from "valtio";
import { markupsStore } from "./pricing-store";
import { Col1, Col12, Col2, Col4, Col5, Col6,  Cols } from "../Controls";
import MonApi from "../state/mongo-api";
import { useEffect } from "react";
import { configStore } from "../state/CommonState";
import CmacgmCountryMarkup from "./cmacgm.country.markup";

export default function FCLpricingCmacgmMarkupEdit(props) {
    useSnapshot(markupsStore)
    useEffect(() => {
        const f = async () => {
            let url = `${process.env.REACT_APP_PRICINGAPI_SERVER}/api/v1/fclpricing/markup/cmacgm`
            let ret = await MonApi.aget(url)
            if (ret.markup) markupsStore.cmacgm = ret.markup
            console.log('GOT RET AS=', ret, '\n==================\n\n')
        }
        f()
    }, [])

    return (
        <>
            <Cols style={{ fontFamily: 'Verdana, sans-serif', textAlign: 'center' }}>
                <Col2 style={{ paddingTop: '1rem' }}>
                    <h4 className="title is-5">
                        Ocean Freight
                    </h4>
                </Col2>
                <Col4>
                    <Cols>
                        <Col12 style={{ fontWeight: 'bold' }}>Mark Up for Per Container</Col12>
                    </Cols>
                    <Cols>
                        <Col6>Percentage</Col6>
                        <Col6>Value in USD</Col6>
                    </Cols>
                    <Cols>
                        <Col6>
                            <input type="number" className="input is-small"
                                value={markupsStore.cmacgm.defaultMarkup.perUnit.percent}
                                style={{ width: '5rem' }}
                                onChange={(ev) => {
                                    markupsStore.cmacgm.defaultMarkup.perUnit.percent = ev.target.value
                                    markupsStore.cmacgm.defaultMarkup.perUnit.value = 0
                                }} />
                        </Col6>
                        <Col6>
                            <input type="number" className="input is-small"
                                value={markupsStore.cmacgm.defaultMarkup.perUnit.value}
                                style={{ width: '5rem' }}
                                onChange={(ev) => {
                                    markupsStore.cmacgm.defaultMarkup.perUnit.value = ev.target.value
                                    markupsStore.cmacgm.defaultMarkup.perUnit.percent = 0
                                }} />
                        </Col6>
                    </Cols>
                </Col4>
                <Col4>
                    <Cols>
                        <Col12 style={{ fontWeight: 'bold' }}>Mark Up for Per BL</Col12>
                    </Cols>
                    <Cols>
                        <Col6>Percentage</Col6>
                        <Col6>Value in USD</Col6>
                    </Cols>
                    <Cols>
                        <Col6>
                            <input type="number" className="input is-small"
                                value={markupsStore.cmacgm.defaultMarkup.perShipment.percent}
                                style={{ width: '5rem' }}
                                onChange={(ev) => {
                                    markupsStore.cmacgm.defaultMarkup.perShipment.percent = ev.target.value
                                    markupsStore.cmacgm.defaultMarkup.perShipment.value = 0
                                }} />
                        </Col6>
                        <Col6>
                            <input type="number" className="input is-small"
                                value={markupsStore.cmacgm.defaultMarkup.perShipment.value}
                                style={{ width: '5rem' }}
                                onChange={(ev) => {
                                    markupsStore.cmacgm.defaultMarkup.perShipment.value = ev.target.value
                                    markupsStore.cmacgm.defaultMarkup.perShipment.percent = 0
                                }} />
                        </Col6>
                    </Cols>
                </Col4>
            </Cols>
            
            
            <hr/>
            <CmacgmCountryMarkup />
            <hr/>
            <section>
                <Cols>
                    <Col5></Col5>
                    <Col1>
                        <button className="button is-danger"
                            onClick={() => {
                                const f = async () => {
                                    let url = `${process.env.REACT_APP_PRICINGAPI_SERVER}/api/v1/fclpricing/markup/cmacgm`
                                    let ret = await MonApi.aget(url)
                                    if (ret.markup) markupsStore.cmacgm = ret.markup
                                    console.log('GOT RET AS=', ret, '\n==================\n\n')
                                }
                                f()
                            }}
                        >Refresh</button>
                    </Col1>
                    <Col2>
                        <button className="button islink"
                            onClick={() => {
                                const f = async () => {
                                    if(markupsStore.freightify._id!="cmacgm"){
                                        markupsStore.freightify._id = "cmacgm"
                                    }
                                    let url = `${process.env.REACT_APP_PRICINGAPI_SERVER}/api/v1/fclpricing/markup/cmacgm`
                                    let ret = await MonApi.apost(url, { markup: markupsStore.cmacgm })
                                    configStore.setModalMessage('Cmacgm markup saved.')
                                }
                                f()
                            }}
                        >Save</button>
                    </Col2>
                </Cols>
            </section>
        </>
    )
}